import React from 'react';
import PrivateRoute from '../../routes/privateRoute';
import {Path} from './constants/config'

const StatisticReport = React.lazy(() => import('./views/StatisticReport'));
const InvoiceReport = React.lazy(() => import('./views/InvoiceReport'));
const UserManagementReport = React.lazy(() => import('./views/UserManagementReport'));
const UserAuditTrailReport = React.lazy(() => import('./views/UserAuditTrailReport'));
const MasterViewReport = React.lazy(() => import('./views/MasterViewReport'));
const DocumentAuditTrailReport = React.lazy(() => import('./views/DocumentAuditTrailReport'));

const MassUpdateLog = React.lazy(() => import('./views/MassUpdateLog'));

const reportRoutes = {
    path: Path.Report,
    name: 'Report',
    icon: 'dripicons-to-do',
    route: PrivateRoute,
    permissions: [{name: ['Report.FullControl']}],
    children: [
        {
            path: Path.StatisticReport,
            name: 'Statistic',
            component: StatisticReport,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'Document.FullControl']},
                {name: ['Report.FullControl', 'Document.ReadOnly']}
            ],
        },
        {
            path: Path.InvoiceReport,
            name: 'Invoice',
            component: InvoiceReport,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'Document.FullControl']},
                {name: ['Report.FullControl', 'Document.ReadOnly']}
            ],
        },
        {
            path: Path.UserManagementReport,
            name: 'User Management',
            component: UserManagementReport,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'User.FullControl']},
                {name: ['Report.FullControl', 'User.ReadOnly']}
            ],
        },
        {
            path: Path.UserAuditTrailReport,
            name: 'User Audit Trail',
            component: UserAuditTrailReport,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'User.FullControl']},
                {name: ['Report.FullControl', 'User.ReadOnly']}
            ],
        },
        {
            path: Path.MasterViewReport,
            name: 'Master View',
            component: MasterViewReport,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'Document.FullControl']},
                {name: ['Report.FullControl', 'Document.ReadOnly']}
            ],
        },
        {
            path: Path.DocumentAuditTrailReport,
            name: 'Document Audit Trail',
            component: DocumentAuditTrailReport,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'Document.FullControl']},
                {name: ['Report.FullControl', 'Document.ReadOnly']}
            ],
        },
        {
            path: Path.MassUpdateLog,
            name: 'Mass Update Log',
            component: MassUpdateLog,
            show: true,
            route: PrivateRoute,
            permissions: [
                {name: ['Report.FullControl', 'Document.FullControl']},
                {name: ['Report.FullControl', 'Document.ReadOnly']}
            ],
        },
    ],
};

export default reportRoutes;
